import { useTranslation } from 'react-i18next'
import { StyleSheet, ViewProps } from 'react-native'
import { WorkspacesFilter, useWorkspaces } from 'zens-store'
import { PageHeaderProps, TablePagination, TableSort } from 'zens-storybook'

import { LayoutHeader } from '../layout'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends PageHeaderProps {
  companyId: number
  pagination?: TablePagination
  sort?: TableSort
  filter?: WorkspacesFilter
}

const WorkspaceListHeader = (props: Props) => {
  const { companyId, pagination, sort, filter, style, ...otherProps } = props
  const { t } = useTranslation()

  const workspaces = useWorkspaces({ companyId, pagination, sort, filter }, { enabled: !!filter })
  return (
    <LayoutHeader
      style={[styles.container, style]}
      title={t('Workspaces')}
      titleRight={workspaces.data?.meta?.total ? ` (${workspaces.data?.meta?.total})` : ''}
      {...otherProps}
    />
  )
}

interface SkeletonProps extends ViewProps {}
const Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props
  return <LayoutHeader.Skeleton style={[styles.container, style]} breadcrumb title {...otherProps} />
}
WorkspaceListHeader.Skeleton = Skeleton

export default WorkspaceListHeader
